import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  protected defaultController = `https://api.${environment.baseUrl}/api/`;
  protected slug = 'coupon';
  constructor(public http: HttpClient, private snackBar: MatSnackBar) {
  }

  public addCoupon(payload: any): Observable<any> {
    return this.http.post(`${this.defaultController}${this.slug}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err41', {
          duration: 5000,
        });
      }));
  }

  public applyCoupon(payload: any): Observable<any> {
    return this.http.post(`${this.defaultController}${this.slug}/apply`, payload)
  }

  public getCoupons(pageNumber: number = 1): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}?pageNumber=${pageNumber}`);
  }

  public updateCoupon(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.defaultController}${this.slug}/${id}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err40', {
          duration: 5000,
        });
      }));
  }

  public deleteCoupon(id: string): Observable<any> {
    return this.http.delete(`${this.defaultController}${this.slug}/${id}`).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err39', {
          duration: 5000,
        });
      }));
  }
}
